import React, { useState, useEffect } from "react";
import { Variables } from "../../Variables1/Variables";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Row,
  Col,
  Modal,
  Button,
  Form,
  Card,
  FormCheck,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import Cookies from "js-cookie";
import Pagination from "../../components/Pagination";

function AlbumsList(props) {
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  const [loader, setLoader] = useState(false);
  const [albums, setAlbums] = useState([]);
  const [search, SetSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [addModalShow, SetAddModalShow] = useState(false);
  const [albumAddToDb, setAlbumAddToDb] = useState({
    AlbumId: 0,
    AlbumName: "",
    MetaTitle: "",
    MetaDescription: "",
    MetaKeyword: "",
    IsPublished: false,
  });
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const [albumUpdateToDb, setAlbumUpdateToDb] = useState({
    AlbumId: 0,
    AlbumName: "",
    MetaTitle: "",
    MetaDescription: "",
    MetaKeyword: "",
    IsPublished: false,
  });
  const [updateModalShow, setUpdateModalShow] = useState(0);

  // Get Albums
  const GetAlbums = async () => {
    setLoader(true);
    let response = await fetch(Variables.API_URL + `Album/GetAlbums?pageNumber=${pageNumber}&pageSize=${pageSize}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    let result = await response.json();
    if (response.status === 200) {
      setAlbums(result.Items);
      setFilteredData(result.Items);
      setTotalCount(result.TotalCount);
    }
    setLoader(false);
  };

  // handle Search
  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    SetSearch(value);
    result = albums.filter((data) => {
      return data.AlbumName.toLowerCase().search(value) !== -1;
    });
    setFilteredData(result);
  };

  // Clear Album Add To Db
  function ClearAlbumAddToDb() {
    SetAddModalShow(false);
    setAlbumAddToDb({
      AlbumId: 0,
      AlbumName: "",
      IsPublished: false,
    });
  }

  // Set Add To Db
  function SetAddToDb() {
    SetAddModalShow(true);
    setAlbumAddToDb({
      AlbumId: 0,
      AlbumName: "",
      IsPublished: false,
    });
  }

  // Set Update ToDb
  function SetUpdateToDb(id, name, isPublished) {
    setUpdateModalShow(id);
    SetUpdateToDb({
      AlbumId: id,
      AlbumName: name,
      IsPublished: isPublished,
    });
  }

  // Clear language Update To Db
  function ClearAlbumUpdateToDb() {
    setUpdateModalShow(0);
    setAlbumUpdateToDb({
      AlbumId: 0,
      AlbumName: "",
      IsPublished: false,
    });
  }

  function handleAddInputs(e) {
    const { name, value } = e.target;

    setAlbumAddToDb((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  // Check input validity
  function IsValidToAdd() {
    var hasError = false;
    var element;
    if (albumAddToDb.AlbumName === null || albumAddToDb.AlbumName === "") {
      element = document.getElementById("AlbumNameToAdd");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Add new Album
  const AddNewAlbum = async () => {
    var Valid = IsValidToAdd();
    if (Valid) {
      let response = await fetch(Variables.API_URL + "Album/AddNewAlbum", {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          AlbumId: albumAddToDb.AlbumId,
          AlbumName: albumAddToDb.AlbumName,
          MetaTitle: albumAddToDb.MetaTitle,
          MetaDescription: albumAddToDb.MetaDescription,
          MetaKeyword: albumAddToDb.MetaKeyword,
          IsPublished: albumAddToDb.IsPublished,
        }),
      });
      let result = await response.json();
      if (response.status === 200) {
        toast.success(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        SetAddModalShow(false);
        setAlbumAddToDb({
          AlbumId: 0,
          AlbumName: "",
          IsPublished: false,
        });
        GetAlbums();
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("Please Select Album Name", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  // handle Updatee Inputs
  function handleUpdateInputs(e) {
    const { name, value } = e.target;

    setAlbumUpdateToDb((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  const HandleUpdateIsDefault = () => {
    if (albumUpdateToDb.IsPublished === true) {
      setAlbumUpdateToDb((prevState) => ({
        ...prevState,
        IsPublished: false,
      }));
    } else {
      setAlbumUpdateToDb((prevState) => ({
        ...prevState,
        IsPublished: true,
      }));
    }
  };

  // Check input validity
  function IsValidToUpdate() {
    var hasError = false;
    var element;
    if (
      albumUpdateToDb.AlbumName === null ||
      albumUpdateToDb.AlbumName === ""
    ) {
      element = document.getElementById("AlbumNameToUpdate");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Update Album
  const UpdateAlbum = async () => {
    var Valid = IsValidToUpdate();
    if (Valid) {
      let response = await fetch(Variables.API_URL + "Album/UpdateAlbum", {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          AlbumId: albumUpdateToDb.AlbumId,
          AlbumName: albumUpdateToDb.AlbumName,
          MetaTitle: albumUpdateToDb.MetaTitle,
          MetaDescription: albumUpdateToDb.MetaDescription,
          MetaKeyword: albumUpdateToDb.MetaKeyword,
          IsPublished: albumUpdateToDb.IsPublished,
        }),
      });
      let result = await response.json();
      if (response.status === 200) {
        toast.success(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setUpdateModalShow(0);
        setAlbumUpdateToDb({
          AlbumId: 0,
          AlbumName: "",
          IsPublished: false,
        });
        GetAlbums();
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("Please Select Album Name", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
    GetAlbums();
  }, [pageNumber, pageSize]);

  return (
    <div>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Albums List</h4>
              </div>
              {Permissions.ManageAlbums === true && (
                <Button variant="primary" onClick={() => SetAddToDb()}>
                  Add New Album
                </Button>
              )}
            </Card.Header>
            <Card.Body className="px-0">
              <Form.Control
                id="Search"
                name="Search"
                placeholder="Search"
                type="text"
                className="allignCenter"
                onChange={handleSearch}
              />
              {loader === true ? (
                <CustomSnipper />
              ) : (
                <div className="table-responsive">
                  <table
                    id="user-list-table"
                    className="table table-striped"
                    role="grid"
                    data-toggle="data-table"
                  >
                    <thead>
                      <tr className="ligth">
                        <th></th>
                        <th>Album Name</th>
                        <th>IsPublished</th>
                        <th min-width="100px">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((tdata, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td
                            onClick={() => {
                              setAlbumUpdateToDb({
                                AlbumId: tdata.AlbumId,
                                AlbumName: tdata.AlbumName,
                                MetaTitle: tdata.MetaTitle ?? "",
                                MetaDescription: tdata.MetaDescription ?? "",
                                MetaKeyword: tdata.MetaKeyword ?? "",
                                IsPublished: tdata.IsPublished,
                              });
                              setUpdateModalShow(tdata.AlbumId);
                            }}
                          >
                            {tdata.AlbumName}
                          </td>
                          <td>
                            <span
                              className={
                                tdata.IsPublished === false
                                  ? "badge bg-danger"
                                  : "badge bg-success"
                              }
                            >
                              {tdata.IsPublished === false
                                ? "Unpublished"
                                : "Published"}
                            </span>
                          </td>
                          <td>
                            {Permissions.ManageAlbums === true && (
                              <div className="flex align-items-center list-user-action">
                                <Link
                                  className="btn btn-sm btn-icon btn-success"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title=""
                                  data-original-title="Edit"
                                  to={"/Album/" + tdata.AlbumId}
                                >
                                  <span className="btn-inner">
                                    <svg
                                      width="20"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                      <path
                                        d="M15.1655 4.60254L19.7315 9.16854"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                    </svg>
                                  </span>
                                </Link>{" "}
                                <Modal
                                  show={updateModalShow == tdata.AlbumId}
                                  onHide={() => ClearAlbumUpdateToDb()}
                                >
                                  <Modal.Header closeButton>
                                    <Modal.Title as="h5">
                                      Update Album : {albumUpdateToDb.AlbumName}
                                    </Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <Row>
                                      <Form.Group className="col-md-12 form-group">
                                        <Form.Label htmlFor="lname">
                                          Album Name:
                                        </Form.Label>
                                        <Form.Control
                                          id="AlbumName"
                                          name="AlbumName"
                                          placeholder="Album Name"
                                          type="text"
                                          value={albumUpdateToDb.AlbumName}
                                          onChange={handleUpdateInputs}
                                        />
                                      </Form.Group>
                                    </Row>
                                    <Row>
                                      <Form.Group className="col-md-12 form-group">
                                        <Form.Label htmlFor="lname">
                                          Meta Title:
                                        </Form.Label>
                                        <Form.Control
                                          id="MetaTitle"
                                          name="MetaTitle"
                                          placeholder="Meta Title"
                                          type="text"
                                          value={albumUpdateToDb.MetaTitle}
                                          onChange={handleUpdateInputs}
                                        />
                                      </Form.Group>
                                    </Row>
                                    <Row>
                                      <Form.Group className="col-md-12 form-group">
                                        <Form.Label htmlFor="lname">
                                          Meta Description:
                                        </Form.Label>
                                        <Form.Control
                                          id="MetaDescription"
                                          name="MetaDescription"
                                          placeholder="Meta Description"
                                          type="text"
                                          value={albumUpdateToDb.MetaDescription}
                                          onChange={handleUpdateInputs}
                                        />
                                      </Form.Group>
                                    </Row>
                                    <Row>
                                      <Form.Group className="col-md-12 form-group">
                                        <Form.Label htmlFor="lname">
                                          Meta Keyword:
                                        </Form.Label>
                                        <Form.Control
                                          id="MetaKeyword"
                                          name="MetaKeyword"
                                          placeholder="Meta Keyword"
                                          type="text"
                                          value={albumUpdateToDb.MetaKeyword}
                                          onChange={handleUpdateInputs}
                                        />
                                      </Form.Group>
                                    </Row>
                                    <Row>
                                      <Form.Group className="col-lg-6 col-md-6 col-sm-12 form-group">
                                        <Form.Label htmlFor="fname">
                                          Is Published :
                                        </Form.Label>
                                        <Form.Check className="mb-3 form-check">
                                          <FormCheck.Input
                                            type="checkbox"
                                            className=""
                                            id="IsPublishedToUodate"
                                            checked={
                                              albumUpdateToDb.IsPublished
                                            }
                                            onChange={(e) =>
                                              HandleUpdateIsDefault()
                                            }
                                          />
                                          <FormCheck.Label
                                            className=""
                                            htmlFor="exampleCheck1"
                                          >
                                            Is Published
                                          </FormCheck.Label>
                                        </Form.Check>
                                      </Form.Group>
                                    </Row>
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button
                                      variant="secondary"
                                      onClick={() => setUpdateModalShow(0)}
                                    >
                                      Close
                                    </Button>
                                    <Button
                                      variant="primary"
                                      onClick={() => UpdateAlbum()}
                                    >
                                      Save changes
                                    </Button>
                                  </Modal.Footer>
                                </Modal>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    pageNumber={pageNumber}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    onPageChange={(newPage) => setPageNumber(newPage)}
                  />

                  <Modal show={addModalShow} onHide={() => ClearAlbumAddToDb()}>
                    <Modal.Header closeButton>
                      <Modal.Title as="h5">Add New Album</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Row>
                        <Form.Group className="col-md-12 form-group">
                          <Form.Label htmlFor="lname">Album Name:</Form.Label>
                          <Form.Control
                            id="AlbumName"
                            name="AlbumName"
                            placeholder="Album Name"
                            type="text"
                            value={albumAddToDb.AlbumName}
                            onChange={handleAddInputs}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-12 form-group">
                          <Form.Label htmlFor="lname">
                            Meta Title:
                          </Form.Label>
                          <Form.Control
                            id="MetaTitle"
                            name="MetaTitle"
                            placeholder="Meta Title"
                            type="text"
                            value={albumAddToDb.MetaTitle}
                            onChange={handleAddInputs}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-12 form-group">
                          <Form.Label htmlFor="lname">
                            Meta Description:
                          </Form.Label>
                          <Form.Control
                            id="MetaDescription"
                            name="MetaDescription"
                            placeholder="Meta Description"
                            type="text"
                            value={albumAddToDb.MetaDescription}
                            onChange={handleAddInputs}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-12 form-group">
                          <Form.Label htmlFor="lname">
                            Meta Keyword:
                          </Form.Label>
                          <Form.Control
                            id="MetaKeyword"
                            name="MetaKeyword"
                            placeholder="Meta Keyword"
                            type="text"
                            value={albumAddToDb.MetaKeyword}
                            onChange={handleAddInputs}
                          />
                        </Form.Group>
                      </Row>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => SetAddModalShow(false)}
                      >
                        Close
                      </Button>
                      <Button variant="primary" onClick={() => AddNewAlbum()}>
                        Save changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default AlbumsList;
